<template>
<div class="my-5 text-center text-white">

    <b-navbar toggleable="lg" type="dark" variant="primary">
        <div class="col-4">
            <p>Ecer</p>
        </div>
        <div class="col-3">
            <p>&copy; 2020 </p>
        </div>
        <div class="col-5">
            <b-badge variant="light" class="mx-1" pill><a href="https://es-la.facebook.com/audicont.consultores" target="_blank"><i class="fab fa-facebook fa-2x"></i></a></b-badge>
            <b-badge variant="light" class="mx-1" pill><a href="https://twitter.com/?lang=es" target="_blank"><i class="fab fa-twitter fa-2x"></i></a></b-badge>
            <b-badge variant="light" class="mx-1" pill><a href="https://www.instagram.com/?hl=es" target="_blank"><i class="fab fa-instagram fa-2x"></i></a></b-badge>

        </div>
    </b-navbar>
</div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>
.circulo {
    border-radius: 50%;
}
</style>
